import { FieldType } from '@ngx-formly/material';
import { RecaptchaComponent } from 'ng-recaptcha';

import { AfterViewInit, Component, ViewChild } from '@angular/core';

import { ISnRecaptchaFormFieldConfig } from '../../interfaces/recaptcha-form-field-config';

@Component({
  selector: 'sn-recaptcha-form-field',
  templateUrl: './recaptcha-form-field.component.html',
  styleUrls: ['./recaptcha-form-field.component.scss'],
})
export class RecaptchaFormFieldComponent
  extends FieldType<ISnRecaptchaFormFieldConfig>
  implements AfterViewInit
{
  @ViewChild('recaptchaComponent') public recaptchaComponent: RecaptchaComponent;

  public readonly defaultOptions: ISnRecaptchaFormFieldConfig = {
    type: 'recaptcha',
    templateOptions: {
      appearance: 'fill',
    },
  };

  constructor() {
    super();
  }

  public ngAfterViewInit(): void {
    if (this.to.afterViewInit) {
      this.to.afterViewInit(this.recaptchaComponent);
    }
  }
}
